import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import {
    CopyToClipboard,
    SuccessResponse,
    VerificationService,
} from '@sheerid/jslib';

interface StepSuccessProps {
    verificationService: VerificationService;
}

const redirect = (redirectDestination: string) => {
    const win = window.open(redirectDestination, '_parent');
    win.focus();
};

const StepSuccess = ({ verificationService }: StepSuccessProps) => {
    const redirectDestination = (verificationService.verificationResponse as SuccessResponse).redirectUrl;
    const showRedirect = Boolean(redirectDestination);
    const rewardCode = (verificationService.verificationResponse as SuccessResponse).rewardCode || '${rewardCode}'; // eslint-disable-line no-template-curly-in-string
    const noCodeType = verificationService.programTheme.config.offerType === 'noCode';

    return (
        <div id="sid-step-success" className="sid-l-container">
            <img className="sid-header__logo" src="https://assets-resources.sheerid.com/jcrew/img/j.crew_logo_2022.png" alt="" />
            <div className="sid-header sid-l-horz-center sid-l-space-top-md">
                <div className="sid-l-horz-center" />
                <h2 className="sid-header__title">
                    <FormattedHTMLMessage id="step.success.title" defaultMessage="Success! You've been verified." />
                </h2>
                <div className="sid-header__subtitle-success sid-l-horz-center sid-l-two-thirds-width">
                    <FormattedHTMLMessage
                        id="step.success.subtitle"
                        defaultMessage={
                            `Here is your personal coupon code.
                        It is unique to you and can only be used once.`
                        }
                    />
                </div>
            </div>

            {
                noCodeType ? null
                    : (
                        <>
                            <div className="sid-reward-code sid-l-space-top-lg sid-h-jumbo-text sid-l-horz-center">
                                {rewardCode}
                            </div>

                            <div className="sid-l-space-top-md sid-h-bold-text sid-l-horz-center">
                                <CopyToClipboard
                                    textToCopy={rewardCode}
                                    notificationText={<FormattedHTMLMessage id="copied" defaultMessage="Copied" />}
                                >
                                    <FormattedHTMLMessage id="step.success.copyCouponCode" defaultMessage="Copy Coupon code" />
                                </CopyToClipboard>
                            </div>
                            <div className="sid-emailed-copy-footer sid-l-horz-center sid-l-space-top-lg sid-success-footer-one">
                                <FormattedHTMLMessage id="step.success.returnTo" />
                            </div>
                            <div className="sid-emailed-copy-footer sid-l-horz-center sid-l-space-top-lg sid-success-footer-two">
                                <FormattedHTMLMessage id="step.success.useDiscount" />
                            </div>
                            <div className="sid-last-footer">
                                <span className="sid-footer-one">
                                    <FormattedHTMLMessage
                                        id="step.personalInfo.lastFooter"
                                        defaultMessage="Verification services hosted by SheerID."
                                    />
                                </span>

                                <p className="sid-footer-two">
                                    <FormattedHTMLMessage id="footerOne" />
                                    {' '}
&nbsp;
                                    <FormattedHTMLMessage id="footerTwo" />
                                </p>

                                <p className="sid-footer-three">
                                    <FormattedHTMLMessage id="step.success.footerThree" />
                                    {' '}
&nbsp;
                                </p>
                            </div>
                        </>
                    )
            }


            {
                (showRedirect)
                    ? (
                        <div className="sid-submit sid-l-space-top-md">
                            <button
                                type="button"
                                onClick={() => redirect(redirectDestination)}
                                className="sid-btn sid-btn--dark"
                            >
                                <FormattedHTMLMessage id="step.success.redirectButtonText" defaultMessage="Use code now" />
                            </button>
                        </div>
                    ) : ''
            }
        </div>
    );
};


export const StepSuccessComponent = StepSuccess;
